module.exports = __webpack_public_path__ + "static/media/success.572b103a.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/diagnostic/success.png
// module id = 5061
// module chunks = 0